import { render, staticRenderFns } from "./ahead.vue?vue&type=template&id=1678ea20&scoped=true"
import script from "./ahead.vue?vue&type=script&lang=ts"
export * from "./ahead.vue?vue&type=script&lang=ts"
import style0 from "./ahead.vue?vue&type=style&index=0&id=1678ea20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1678ea20",
  null
  
)

export default component.exports